import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { namespace } from '@/modules/driver/namespace';

import { setAllDrivers } from '../actions';

const loadAllDrivers = createAsyncThunk(
  `${namespace}/load-all-drivers`,
  async (_, { dispatch }) => {
    const drivers = await driverAPI.fetchBriefDrivers();

    dispatch(setAllDrivers(drivers.items));

    return drivers;
  },
);

export { loadAllDrivers };
